import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/:event",
    name: "Cart",
    component: () => import("../views/Cart.vue"),
  },
  {
    path: "/:event/payment",
    name: "Payment",
    component: () => import("../views/Payment.vue"),
  },
  {
    path: "/:event/finished",
    name: "Finished",
    component: () => import("../views/Finished.vue"),
  },
  {
    path: "/:event/participants",
    name: "Participants",
    component: () => import("../views/Participants.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (store.state.auth.widgetMode) {
    store.commit("SET_STEP", to.name);
  } else {
    next();
  }
});

export default router;
